import React from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { EntityInterfaceWithChildIds } from '@email-editor/ui'
import * as managementActions from '../../../store/management/actions'
import useDropBox from './useDropBox'
import { DropBox } from './DropBox'
import { twMerge } from 'tailwind-merge'

type DropBoxEmptyProps = {
  parentEntity: EntityInterfaceWithChildIds
}

const DropBoxEmpty = ({ parentEntity }: DropBoxEmptyProps) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { canDrop, connect } = useDropBox(parentEntity)

  const showPopupLibrary = (event: React.SyntheticEvent) => {
    event.stopPropagation()
    dispatch(managementActions.setInsertToForPopupLibrary(parentEntity.id))
  }

  return (
    <DropBox ref={connect} canDrop={canDrop}>
      <tbody>
        <tr>
          <td
            onClick={showPopupLibrary}
            className={twMerge(
              'font-inter border-brand-primary main-transition-colors flex cursor-pointer items-center justify-center border border-dashed p-5',
              canDrop
                ? 'bg-brand-primary/30 text-brand-primary'
                : 'bg-brand-primary/10 text-brand-primary',
            )}
          >
            {t('core.empty_dropbox_text')}
          </td>
        </tr>
      </tbody>
    </DropBox>
  )
}

export default DropBoxEmpty
